import { Component, OnInit, OnDestroy } from '@angular/core';
import {debounceTime} from 'rxjs/operators';
import { ConsumerInteractionService } from '../../../services/consumer-interaction.service';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DeviceInteractionService } from '../../../services/device-interaction.service';
import { PagedConsumerInteractionModel } from '../../../models/consumer/consumer-interaction.model';
import swal from 'sweetalert2';
import { ClaimsService } from '../../../services/claims.service';

@Component({
  selector: 'device-interaction',
  templateUrl: './device-interaction.component.html',
  styles: []
})
export class DeviceInteractionComponent implements OnInit, OnDestroy {

    constructor(
        private consumerInteractionService: ConsumerInteractionService,
        private route: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private deviceInteractionService: DeviceInteractionService,
        private claimsService: ClaimsService) { }

    subscriptions: any[] = [];
    clientId: number;
    deviceInteractionId: string;
    interactions: any[] = [];
    form: UntypedFormGroup;
    BulkIdTitle: string = "";
    filterTerm: string;
    filterList: any[] = [];
    searchTerm: string = "";
    isSearching: boolean = false;
    page: number = 1;
    pageSize: number = 20;
    totalPages: number;
    inProgressCount: number;
    totalItems: number;
    completedCount: number;
    myInteractionsCount: number;
    errorCount: number;
    deviceStatus: string = "";
    isScheduled: boolean = false;

    ngOnInit() {
        this.subscriptions.push(this.router.events.subscribe((val) => {

            if (val instanceof NavigationStart) {
                let urlParts = val.url.split('/');
                if (!urlParts.find(x => x.toLowerCase() == 'bulk' || x.toLowerCase() == 'consumer')) {
                    window.sessionStorage.removeItem('device-interaction-id');
                }
            }
        }));

        this.deviceInteractionId = this.deviceInteractionService.id;

        this.clientId = this.route.parent.snapshot.params['clientId'];

        this.form = this.fb.group({
            'searchTerm': ["", Validators.compose([Validators.maxLength(120)])],
        });

        this.subscriptions.push(this.form.controls['searchTerm'].valueChanges.pipe(debounceTime(500)).subscribe(searchResult => {
            this.search(searchResult);
        }));

        this.getInteraction();
    }

    navigateBack() {
        this.router.navigate([/portal/ + this.clientId.toString() + '/deviceinteractions']);
    }

    filterClick(item: any) {
        this.filterList.map(x => x.isClicked = false);
        item.isClicked = true;
        item.label != "All" ? this.filterTerm = item.key : this.filterTerm = "";
        this.getInteraction(this.searchTerm, this.filterTerm);
    }

    setDeviceStatus(deviceinteractionRes: PagedConsumerInteractionModel) {
        if (deviceinteractionRes.inProgressCount > deviceinteractionRes.completedCount
         && deviceinteractionRes.inProgressCount > deviceinteractionRes.errorCount) {
        this.deviceStatus = "In Progress"
        }

        if (deviceinteractionRes.completedCount > deviceinteractionRes.inProgressCount
         && deviceinteractionRes.completedCount > deviceinteractionRes.errorCount) {
            this.deviceStatus = "Completed"
        }

        if (deviceinteractionRes.errorCount > deviceinteractionRes.completedCount
         && deviceinteractionRes.errorCount > deviceinteractionRes.inProgressCount) {
            this.deviceStatus = "Error"
        }
    }

    clickConsumer(item: any) {
        window.sessionStorage.setItem("RequestType", item.requestName);
        this.router.navigate(['/portal/' + item.clientID + '/consumer', item.consumerID]);
    }

    CreateOrUpdateFilter() {

        if (this.filterList.length > 0) return;

        this.filterList.push(
            {
                key: "all",
                label: "All",
                count: this.totalItems,
                isClicked: true,
            },
            {
                key: "inprogress",
                label: "In Progress",
                count: this.inProgressCount,
                isClicked: false,
            },
            {
                key: "completed",
                label: "Completed",
                count: this.completedCount,
                isClicked: false,
            },
            {
                key: "error",
                label: "Error",
                count: this.errorCount,
                isClicked: false,
            },
        )
    }

    pageSelected(page: number) {
        this.page = page;
        this.getInteraction(this.searchTerm, this.filterTerm);
    }

    getInteraction(searchTerm?: string, filters?: string) {
        this.isSearching = true;
        this.consumerInteractionService.getSingleClientInteraction(this.clientId, this.deviceInteractionId, this.page, this.pageSize, searchTerm, filters).then((deviceinteractionRes) => {
            this.interactions = deviceinteractionRes.items;
            this.page = deviceinteractionRes.currentPage;
            this.pageSize = deviceinteractionRes.pageSize
            this.totalPages = deviceinteractionRes.totalPages;
            this.totalItems = deviceinteractionRes.totalItems;
            this.inProgressCount = deviceinteractionRes.inProgressCount;
            this.completedCount = deviceinteractionRes.completedCount;
            this.errorCount = deviceinteractionRes.errorCount;
            this.myInteractionsCount = deviceinteractionRes.myInteractionCount;
            if (deviceinteractionRes.items.length) {
                this.BulkIdTitle = deviceinteractionRes.items[0].bulkID.toUpperCase();
            }
            this.isScheduled = (deviceinteractionRes.inProgressCount == deviceinteractionRes.totalItems
                              && deviceinteractionRes.items[0].scheduleTime != null
                && (deviceinteractionRes.myInteractionCount == deviceinteractionRes.totalItems));
            this.isSearching = false;
            this.CreateOrUpdateFilter();
            this.setDeviceStatus(deviceinteractionRes);
            this.filterList[0].count = deviceinteractionRes.totalItems;
            this.filterList[1].count = deviceinteractionRes.inProgressCount;
            this.filterList[2].count = deviceinteractionRes.completedCount;
            this.filterList[3].count = deviceinteractionRes.errorCount;
        }).catch((error) => {
            console.log("failed to  get interactions: " + error);
            this.isSearching = false;
        }) 
    }

    search(searchTerm?: string) {
        this.searchTerm = searchTerm;
        if (!searchTerm) {
            this.searchTerm = this.form.controls['searchTerm'].value;
        }
        this.getInteraction(this.searchTerm);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    submit(form: UntypedFormGroup) {
        this.search(this.searchTerm);
    }

    cancelInteractions() {

        if (this.inProgressCount == this.totalItems) {

            swal({
                title: "Are you sure you want to cancel these interactions?",
                text: "You are about to cancel the following interactions",
                confirmButtonText: 'Yes',
                confirmButtonColor: '#00539f',
                showCancelButton: true,
                cancelButtonText: "No, don't cancel",
                cancelButtonColor: '#00539f',
            }).then(val => {
                if (val.value == true) {
                    let id = JSON.parse(window.sessionStorage.getItem("device-interaction-id"));
                    let userId = this.claimsService.userId;
                    this.consumerInteractionService.CancelBulkInteraction(this.clientId, id, userId).then(cancelResult => {
                        window.sessionStorage.removeItem("device-interaction-id");
                        this.navigateBack();
                    }).catch(error => {

                        swal({
                            title: 'Something went wrong',
                            text: 'An error occured, could not cancel the interactions, please try again later or contact the switch2 technical team on: XXXX',
                            type: 'error',
                            confirmButtonText: 'Continue'
                        })
                    })
                }
            });
        }
    }
}
